import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/Rx';
import {Observable} from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FileService {

constructor(
  private _http: HttpClient
) { }


downloadFileExcel(nombrearchivo: string) {
  const body = {filename: nombrearchivo};

  // return this._http.post('http://localhost:3000/upload/descarga', body, {
 // return this._http.post('https://www.app.sportfishingmx.com/upload/descarga', body, {
  return this._http.post(environment.rutaweb, body, {
      responseType : 'blob',
      headers: new HttpHeaders().append('Content-Type', 'application/json')
  });
}






downloadFilePDF(nombrearchivo: string) {
  const body = {filename: nombrearchivo};
  console.log (body);

  // return this._http.post('http://localhost:3000/upload/descarga', body, {
  return this._http.post(environment.rutaweb, body, {
      responseType : 'blob',
      headers: new HttpHeaders().append('Content-Type', 'application/json')
  });
}

}
